import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'lib-enum-dropdown',
  templateUrl: './enum-dropdown.component.html',
  styleUrls: ['./enum-dropdown.component.scss'],
  standalone: false
})
export class EnumDropdownComponent {
  @Input() label!: string;
  @Input() enumObject: any;   
  @Input() isLabelled: boolean = false;
  @Input() initialValue: any = null;
  @Input() disabled: boolean = false;

  @Output() valueChange = new EventEmitter<any>();

  options: {key: string; label: string}[] = [];    
  selected: string | null = null;
  isOpen = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['enumObject'] && this.enumObject) {
      const noSplit = ['kVA'] // values that should not be split by casing
      this.options = Object.keys(this.enumObject)
        .filter(k => isNaN(Number(k)))
        .map(opt => ({
          key: opt,
          label: noSplit.includes(opt)
            ? opt
            : opt.replace(/([a-z])([A-Z])/g, '$1 $2')
        }));
    }

    if (this.enumObject && this.options.length > 0) {
      if (this.initialValue != null) {
        this.setInitialSelected();
      } else {
        this.selected = null;
      }
    }
  }

  private setInitialSelected() {
    const key = Object.keys(this.enumObject).find(
      k => this.enumObject[k] === this.initialValue
    );

    if (key) {
      const opt = this.options.find(o => o.key === key);
      this.selected = opt ? opt.label : String(this.initialValue);
    } else {
      this.selected = String(this.initialValue);
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: { key: string; label: string }, event?: Event) {
    event?.stopPropagation();
    this.selected = option.label;
    this.valueChange.emit(this.enumObject[option.key]);
    this.isOpen = false;
  }
}
